import React from 'react';
import { closeActiveTooltip } from '../../../../components/TooltipBtn';
import { codes } from '../../../../data/translations';
import { getItemClasses } from './utils';
import classes from './styles/index.module.scss';
import { useStyleContextState } from '../../../styleContext';
import { gray, white } from '../../../../components/Color';
import { ThemeStyle } from '../../../../utils/const';
import { useTranslationAPI } from '../../../translations';
import { useHeaderActionsProvider } from '../HeaderActionsProvider';
import { Gear } from '../../../../components/Icons/Gear';
import { syncManager } from '../../../../utils/syncManager';

const HeaderUserActionsChangePassword = () => {
	const { theme } = useStyleContextState();
	const { translate } = useTranslationAPI();
	const iconColor = theme === ThemeStyle.Dark ? white : gray[7];
	const { openChangePasswordModal } = useHeaderActionsProvider();

	const handleChangePasswordButtonClick = () => {
		syncManager.emit('react', 'onPasswordChange');

		closeActiveTooltip();
		openChangePasswordModal();
	};

	return (
		<button
			className={getItemClasses({ theme })}
			type='button'
			onClick={handleChangePasswordButtonClick}
		>
			<Gear
				className={classes.buttonIcon}
				fill={iconColor}
			/>
			<span>{translate(codes.changePassword)}</span>
		</button>
	);
};

export default HeaderUserActionsChangePassword;
